/**
 * 新建反馈类型
 */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styles from './FeedModal.module.scss';
import http from '@/assets/api/http';
import {
    Modal,
    message,
    Form,
    Input,
    Checkbox,
    Row,
    Col
} from 'antd';

const FormItem = Form.Item;

const layout = {
    labelCol: {
        span: 4,
        offset: 2
    },
    wrapperCol: {
        span: 19,
    },
};

const TempModal = ({
    closeMode,
    ...restProps
}) => {

    const [title, setTitle] = useState(restProps.title);
    const [visible, setVisible] = useState(restProps.visible);
    const [confirmLoading, setConfirmLoading] = useState(false);
    const [form] = Form.useForm();
    const [systemTypeEnum, setSystemTypeEnum] = useState([]);

    useEffect(() => {
        http('/?cmd=com.xqxc.api.pig.mis.biz.platform.PfEnumMisService.getEnum', { enumName: 'IdeaBackSystemTypeEnum' }, 'POST')
            .then(res => {
                setSystemTypeEnum(res.result);
            });
    }, []);

    const _handleOk = () => {
        form.validateFields().then((values) => {
            let submitData = {
                feedBackType: values.feedbackName,
                systemType: values.systemType.join(',')
            };
            setConfirmLoading(true);
            http('/?cmd=com.xqxc.api.pig.mis.biz.platform.FeedBackService.insert', submitData, 'POST').then(() => {
                message.success('新建成功');
                setVisible(false);
                closeMode(true);
            }).catch((e = {}) => {
                message.error(e.message || '提交异常');
                setConfirmLoading(false);
            });
        }).catch(() => { });
    }

    const _handleCancel = () => {
        setVisible(false);
        closeMode();
    }


    return (
        <Modal
            width={520}
            centered
            title={title}
            visible={visible}
            confirmLoading={confirmLoading}
            onOk={_handleOk}
            onCancel={_handleCancel}
            destroyOnClose={true}
            keyboard={true}
            maskClosable={false}
            cancelText='取消'
            okText='确认'
        >

            <Form
                {...layout}
                className={styles.container}
                autoComplete='off'
                name="create"
                scrollToFirstError
                form={form}
            >
                <FormItem className={`${styles.flexCurt}`}>
                    <FormItem
                        name="feedbackName"
                        label="反馈类型"
                        colon={false}
                        rules={[
                            {
                                required: true, min: 2, max: 8, type: 'string'
                            },
                        ]}
                    >
                        <Input
                            style={{ width: 180 }}
                            placeholder="请输入"
                            suffix={<FormItem
                                noStyle
                                shouldUpdate
                            >
                                {({ getFieldValue }) => {
                                    return getFieldValue('feedbackName') ? (
                                        <span key={getFieldValue('feedbackName')}>{getFieldValue('feedbackName').length}/8</span>
                                    ) : <span>0/8</span>;
                                }}
                            </FormItem>}
                            maxLength={8}
                        />
                    </FormItem>
                    <span className={styles.curt}>要求2至8个字符</span>
                </FormItem>
                <Form.Item
                    name='systemType'
                    label='反馈渠道'
                    colon={false}
                    rules={[
                        { type: 'array', required: true, message: '请勾选反馈渠道' },
                    ]}
                    style={{ paddingLeft: '15px' }}
                >
                    <Checkbox.Group>
                        <Row>
                            {
                                systemTypeEnum.map(item => (
                                    < Col key={item.code} span={12} >
                                        <Checkbox
                                            value={item.code}
                                            style={{ lineHeight: '32px' }}
                                        >{item.value}</Checkbox>
                                    </Col>
                                ))
                            }
                        </Row>
                    </Checkbox.Group>
                </Form.Item>
            </Form>
        </Modal >
    );

}

TempModal.propTypes = {
    data: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.object
    ]), // 弹框入参
    visible: PropTypes.bool.isRequired, // 是否显示弹框
    closeMode: PropTypes.func.isRequired, // 关闭弹框的回调函数
    title: PropTypes.string,// 弹框标题
};

export default TempModal;